/* eslint max-params: ["error", 5] */
import { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { newResourceFromDataset } from "actionCreators/resources"
import { clearErrors } from "actions/errors"
import { selectCurrentResourceKey } from "selectors/resources"
import { useNavigate } from "react-router-dom"

/**
 * Hook for transforming a resource to state and changing the page to the editor (i.e., /editor path).
 * @param {rdf.Dataset} dataset containing resource
 * @param {string} baseURI of the resource
 * @param {string} resourceTemplateId to use for the resource
 * @param {string} errorKey to use when adding errors to state
 * @param {Object} navigate react-router navigate function
 * @return {[Object, rdf.Dataset, string]} resource state, unused RDF, error
 */
const useRdfResource = (dataset, baseURI, resourceTemplateId, errorKey) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const hasResource = useSelector((state) => !!selectCurrentResourceKey(state))

  // Indicates that would like to change to editor once resource is in state
  const [navigateEditor, setNavigateEditor] = useState(false)

  useEffect(() => {
    if (!dataset || baseURI === undefined || !resourceTemplateId) {
      return
    }
    dispatch(clearErrors(errorKey))
    dispatch(
      newResourceFromDataset(
        dataset,
        baseURI,
        resourceTemplateId,
        errorKey,
        true,
      ),
    ).then((result) => {
      setNavigateEditor(result)
    })
  }, [dataset, baseURI, resourceTemplateId, dispatch, errorKey])

  useEffect(() => {
    // Forces a wait until the root resource has been set in state
    if (navigateEditor && hasResource) {
      navigate("/editor")
    }
  }, [navigateEditor, navigate, hasResource])
}

export default useRdfResource
